import { isWindowActiveAt } from './evaluate.js';
import { getZonedClock } from './timezone.js';
/**
 * Picks the winning override among candidate rules at `now` in `timeZone`.
 * Returns `{ status: 'none' }` when nothing is active (fail-safe → default playlist).
 */
export function resolveActiveSchedule(input) {
    const clock = getZonedClock(input.now, input.timeZone);
    const active = input.rules.filter((rule) => isWindowActiveAt(rule, clock));
    if (active.length === 0) {
        return { status: 'none' };
    }
    active.sort(compareScheduleRules);
    return { status: 'override', rule: active[0] };
}
/**
 * Sort comparator: higher priority first, then screen over group, then newer updatedAt.
 */
export function compareScheduleRules(a, b) {
    if (a.priority !== b.priority) {
        return b.priority - a.priority;
    }
    const specificityRank = { screen: 1, group: 0 };
    const specificityDelta = specificityRank[b.targetSpecificity] - specificityRank[a.targetSpecificity];
    if (specificityDelta !== 0) {
        return specificityDelta;
    }
    return b.updatedAt.localeCompare(a.updatedAt);
}
//# sourceMappingURL=resolve.js.map